import { getCircles } from "@/lib/api/circle"
import { useCircleStore } from "@/lib/store/circle"
import { queryKeys } from "@/lib/utils/query"
import { CirclesResponse } from "@/types/circle"
import { useQuery } from "@tanstack/react-query"
import { useEffect } from "react"

export const useCircles = () => {
  const { selectedCircleId, loading, setLoading, setCircles } = useCircleStore()

  const { data, isLoading, error } = useQuery<CirclesResponse>({
    queryKey: queryKeys.circles,
    queryFn: getCircles,
    staleTime: 1000 * 60 * 5,
    gcTime: 1000 * 60 * 10,
  })

  useEffect(() => {
    if (data?.results) {
      setCircles(data.results)
    }
  }, [data, setCircles])

  useEffect(() => {
    setLoading(isLoading)
  }, [isLoading])

  return {
    selectedCircleId,
    loading,
    error,
  }
}
